<tool-drawer-container (openFormDialog)="openDialog()">
  <prerequisites-form class="form-slot"></prerequisites-form>

  <tool-header
    class="tool-header"
    headerTitle="Prerequisite Impact"
    subtitle="View the impact of prerequisites on a target course"
  ></tool-header>

  <app-prerequisites-content class="main-content"></app-prerequisites-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Prerequisite Impact'
      )
    "
  ></related-links>
</tool-drawer-container>
